import React from 'react';
import { Box, Alert, AlertTitle, Button } from '@mui/material';

/**
 * Consistent error panel with an optional retry action. Presentation only —
 * callers own the actual retry/fetch logic.
 */
const ErrorState = ({
  title = 'Something went wrong',
  message,
  onRetry,
  retryLabel = 'Try again',
  sx,
}) => {
  return (
    <Box sx={{ py: 2, ...sx }}>
      <Alert
        severity="error"
        action={
          onRetry ? (
            <Button color="inherit" size="small" onClick={onRetry}>
              {retryLabel}
            </Button>
          ) : undefined
        }
      >
        {title && <AlertTitle sx={{ fontWeight: 700 }}>{title}</AlertTitle>}
        {message}
      </Alert>
    </Box>
  );
};

export default ErrorState;
